import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {useHistory, useParams} from "react-router-dom";
import {get_groups, update_group, clearStatus, UPDATE_GROUP} from '../../redux/bases'
import MultiselectTwoSides from 'react-multiselect-two-sides';
import "./create.scss";

const EditarUsuario = () => {
    let history = useHistory();
    const {id} = useParams();

    const _get_groups = useSelector((store) => store.bases._get_groups);
    const editar_grupo = useSelector((store) => store.bases._update_group);
    const _get_permissions = useSelector((store) => store.bases._get_permissions);
    const { token } = useSelector((store) => store.auth);

    const [data,setData] = useState({
        nombre:'',
        permisos: [],
    });

    const [permission, setPermission] = useState([]);
    const [permissionSelect, setPermissionSelect] = useState([]);

    const [msj, setMsj] = useState("");
    const dispatch = useDispatch();

    useEffect(() => {
        if (_get_groups) {
            const item = _get_groups.find((item) => parseInt(item.id) === parseInt(id));
            if (item) {
                let permisos = [];
                let permisoSelect = [];
                // eslint-disable-next-line
                item.permisos.map((it) => {
                    permisos.push({codigo: it.codigo});
                    permisoSelect.push(it.codigo);
                })
                setData({nombre: item.nombre, permisos: permisos});
                setPermissionSelect(permisoSelect);
            }
        }
    }, [id, _get_groups]);
    
    useEffect(() => {
        console.log(editar_grupo)
        if (editar_grupo === 200 && token) {
            dispatch(get_groups(token));
            dispatch(clearStatus(UPDATE_GROUP, 0));
            history.push("/roles-permisos");
        } else if (editar_grupo === 1) {
            setMsj("Ocurrio un error al editar");

        }
    }, [editar_grupo, token, dispatch, history]);

    useEffect(() => {
        if (_get_permissions) {
            let datos = [];
            // eslint-disable-next-line
            _get_permissions.map((item) => {
                datos.push({
                    name: item.nombre,
                    value: item.codigo,
                })
            });
            setPermission(datos);
        }
    }, [_get_permissions]);

    const handleChangeMultiselect = (e) => {
        setPermissionSelect(e);
        let permisos = [];
        // eslint-disable-next-line
        e.map((item) => {
            permisos.push({codigo: item});
        })
        setData({
            ...data,
            permisos: permisos,
        });
    }

    const {nombre, permisos} = data;

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!nombre || permisos.length === 0) {
            setMsj("Completa todos los campos");

        } else {
            dispatch(update_group(id, data, token));

        }
    };

    const canceled = () => {
        if(token){
            dispatch(get_groups(token))
        }
        dispatch(clearStatus(UPDATE_GROUP, 0));
        history.push("/roles-permisos");
    }

    const onInputChange = e => {
        setData({ ...data, [e.target.name]: e.target.value });
    };

    return(
        <>
            <div className="section-header">
                <h1>Editar rol</h1>
            </div>

            <div className="col-12 col-md-12 col-lg-12">
                <div className="card">
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div className="card-header">
                            <h4>Datos del rol</h4>
                        </div>
                        {
                            msj ? (<div class="alert alert-danger m-3">
                                {msj}
                            </div>) : (null)
                        }
                        <div className="card-body row">
                            <div className="col-6 col-md-6 col-lg-6">
                                <div className="form-group">
                                    <label>Nombre</label>
                                    <input type="text" name="nombre" className="form-control" required="" onChange={e => onInputChange(e)} value={nombre}/>
                                </div>
                            </div>
                            <div className="col-12">
                                <MultiselectTwoSides
                                    options={permission}
                                    value={permissionSelect}
                                    className="msts_theme_example"
                                    onChange={handleChangeMultiselect}
                                    availableHeader="Permisos Disponibles"
                                    selectedHeader="Permisos Seleccionados"
                                    labelKey="name"
                                    showControls
                                    searchable
                                />
                            </div>
                        </div>

                        <div className="card-footer text-right">
                            <button className="btn btn-success">Guardar</button>
                            <button type="button" className="btn btn-danger" onClick={() => canceled()}>Cancelar</button>
                        </div>
                    </form>
                </div>

            </div>
        </>
    )
}

export default EditarUsuario;